import { Loader2, CheckCircle2, AlertTriangle } from "lucide-react";

type StockClosingStatusProps = {
  fetching: boolean;
  lastClosedAt: Date | null;
  needsClosing: boolean;
  missingDays: number;
  missingStockVariantsCount?: number;
};

export function StockClosingStatus({
  fetching,
  lastClosedAt,
  needsClosing,
  missingDays,
  missingStockVariantsCount = 0,
}: StockClosingStatusProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-1.5 sm:gap-2 text-xs sm:text-sm text-slate-600">
      <div className="flex items-center gap-1.5 sm:gap-2 flex-wrap">
        <span className="whitespace-nowrap">Last closed:</span>
        <span className="font-medium">
          {fetching && (
            <span className="inline-flex items-center gap-1.5 sm:gap-2">
              <Loader2 className="h-3.5 w-3.5 sm:h-4 sm:w-4 animate-spin" /> Loading…
            </span>
          )}
          {!fetching && lastClosedAt && lastClosedAt.toLocaleDateString()}
          {!fetching && !lastClosedAt && (
            <em className="text-slate-500">Unknown</em>
          )}
        </span>
      </div>

      <div className="flex items-center gap-1.5 sm:gap-2 flex-wrap">
        {missingDays > 0 && (
          <span className="inline-flex items-center gap-1 rounded-full bg-amber-50 text-amber-700 px-2 py-0.5 text-xs font-medium">
            <AlertTriangle className="h-3 w-3 sm:h-3.5 sm:w-3.5" /> {missingDays} day
            {missingDays === 1 ? "" : "s"} pending
          </span>
        )}

        {missingStockVariantsCount > 0 && (
          <span className="inline-flex items-center gap-1 rounded-full bg-amber-50 text-amber-700 px-2 py-0.5 text-xs font-medium">
            <AlertTriangle className="h-3 w-3 sm:h-3.5 sm:w-3.5" /> {missingStockVariantsCount}{" "}
            variant
            {missingStockVariantsCount === 1 ? "" : "s"} missing
          </span>
        )}

        {!needsClosing && (
          <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 text-emerald-700 px-2 py-0.5 text-xs font-medium">
            <CheckCircle2 className="h-3 w-3 sm:h-3.5 sm:w-3.5" /> Up to date
          </span>
        )}
      </div>
    </div>
  );
}
